const routes = [
  {
    path: 'checklist-report',
    name: 'checklistReport',
    component: () => import(/* webpackChunkName: "checklist-report" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
  },
];

export default routes;
